<template>
  <div class="quen-unlock-widget-edit relative">
    <!-- 活动选择 -->
    <menu-item label="活动">
      <activity-select v-model="model.bizId" :chain-id.sync="model.chainId" :type="14" />
    </menu-item>

    <!-- 背景设置 -->
    <menu-item :label="$t('head.backImg')" class="menu-item-switch" pt="0px">
      <menu-fill :target="model.background" target-key="background" />
      <menu-background-image class="mt-2" :target="model.background" target-key="background" />
    </menu-item>
    <menu-divider />
    <!-- 布局 -->
    <menu-item :label="$t('menu.layout')" class="menu-item-switch" pt="0px">
      <menu-switch v-model="model.titleVisible" label="标题" target-key="titleVisible" />
      <menu-switch v-model="model.subtitleVisible" class="mt-2" label="描述" target-key="subtitleVisible" />
    </menu-item>

    <menu-item label="倒计时背景色">
      <menu-fill :target="model.countdownBackground" solid-color target-key="countdownBackground" />
    </menu-item>
    <menu-item label="倒计时背景文字色">
      <menu-fill :target="model.countdownTextColor" solid-color target-key="countdownTextColor" />
    </menu-item>
    <!-- 商品卡片背景 -->
    <menu-item label="商品卡片背景">
      <menu-background-image :target="model.cardBackground" target-key="cardBackground" />
      <menu-fill class="mt-2" :target="model.cardBackground" target-key="cardBackground" />
    </menu-item>

    <!-- 商品LOGO背景 -->
    <menu-item label="商品LOGO背景">
      <menu-background-image :target="model.logoBackground" target-key="logoBackground" />
      <menu-fill class="mt-2" :target="model.logoBackground" target-key="logoBackground" />
    </menu-item>

    <!-- 商品文字色 -->
    <menu-item label="商品文字色">
      <menu-fill :target="model.textColor" solid-color target-key="textColor" />
    </menu-item>

    <!-- 圆角 -->
    <menu-item label="圆角">
      <menu-slider v-model="model.radius" target-key="radius" />
    </menu-item>

    <!-- 卡片阴影 -->
    <menu-item label="卡片阴影">
      <menu-slider v-model="model.cardShadow" :max="50" target-key="cardShadow" />
    </menu-item>

    <!-- 可操作按钮（当前可购买/可领取的档位） -->
    <menu-item label="可操作按钮填充色">
      <menu-background-image :target="model.operableButtonBackground" target-key="operableButtonBackground" />
      <menu-fill class="mt-2" :target="model.operableButtonBackground" target-key="operableButtonBackground" />
    </menu-item>
    <menu-item label="可操作按钮文字色">
      <menu-fill :target="model.operableButtonTextColor" solid-color target-key="operableButtonTextColor" />
    </menu-item>

    <!-- 不可操作按钮（未解锁、已购买、已领取的档位） -->
    <menu-item label="不可操作按钮填充色">
      <menu-background-image :target="model.inoperableButtonBackground" target-key="inoperableButtonBackground" />
      <menu-fill class="mt-2" :target="model.inoperableButtonBackground" target-key="inoperableButtonBackground" />
    </menu-item>
    <menu-item label="不可操作按钮文字色">
      <menu-fill :target="model.inoperableButtonTextColor" solid-color target-key="inoperableButtonTextColor" />
    </menu-item>

    <!-- 连线箭头填充 -->
    <menu-item label="连接线ICON">
      <menu-background-image :target="model.arrowBackground" target-key="arrowBackground" />
    </menu-item>

    <menu-item label="加锁ICON">
      <menu-background-image :target="model.lockBackground" image-size-key="" target-key="lockBackground" />
    </menu-item>

    <!-- 操作 -->
    <menu-button class="mt-4" icon="add" :help-text="$t('menu.copyBlock')" @click.native.stop="handleClone">{{ $t('menu.createCopy') }}</menu-button>
    <remove-btn class="mt-4" />
  </div>
 </template>

 <script>
 import ActivitySelect from '~/site/components/activitySelect/index.vue'
 import RemoveBtn from "~/components/common/RemoveBtn.vue";
 import MenuItem from "~/components/menu/menuItem.vue";
 import MenuBackgroundImage from "~/components/menu/menuBackgroundImage.vue";
 import MenuSwitch from "~/components/menu/menuSwitch.vue";
 import MenuFill from "~/components/menu/menuFill.vue";
 import MenuSlider from "~/components/menu/menuSlider.vue";
 import MenuDivider from "~/components/menu/divider";
 import MenuButton from "~/components/menu/menuButton.vue";

 export default {
  name: 'QuenUnlockWidgetEdit',
  components: { ActivitySelect, RemoveBtn, MenuItem, MenuBackgroundImage, MenuSwitch, MenuFill, MenuSlider, MenuDivider, MenuButton },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClone() {
      const cloned = this.model && this.model.clone ? this.model.clone() : JSON.parse(JSON.stringify(this.model || {}))
      this.$emit('clone', cloned)
    }
  }
 }
 </script>